var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import messages from '@/modules/documents/documentMessages';
import { SpinnerIcon } from '@/shared/components/Icons';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { FormattedMessage } from 'react-intl';
import { SharepointFolderTree } from '@/modules/documents/modals/SharepointFolderTree';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import { SharepointFileSelector } from '@/modules/documents/modals/SharepointFileSelector';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
var LinkFromSharepointModal = function (_a) {
    var _b, _c, _d, _e;
    var show = _a.show, intl = _a.intl, onSave = _a.onSave, onClose = _a.onClose, relationId = _a.relationId, tags = _a.tags;
    var _f = useState([]), sites = _f[0], setSites = _f[1];
    var _g = useState(false), foldersLoading = _g[0], setFoldersLoading = _g[1];
    var _h = useState(true), sitesLoading = _h[0], setSitesLoading = _h[1];
    var _j = useState(null), selectedSiteId = _j[0], setSelectedSiteId = _j[1];
    var _k = useState(false), drivesLoading = _k[0], setDrivesLoading = _k[1];
    var _l = useState([]), drives = _l[0], setDrives = _l[1];
    var _m = useState(null), selectedDriveId = _m[0], setSelectedDriveId = _m[1];
    var _o = useState('/'), selectedFolderId = _o[0], setSelectedFolderId = _o[1];
    var _p = useState(null), selectedFileId = _p[0], setSelectedFileId = _p[1];
    var _q = useState(null), selectedFileName = _q[0], setSelectedFileName = _q[1];
    useEffect(function () {
        setSitesLoading(true);
        api.base
            .get("".concat(config.appUrls.documents, "/api/sharepoint/sites"))
            .then(function (x) {
            setSites(!x.data ? [] : x.data);
        }, function (error) {
            handleHttpError(intl)(error);
        })
            .finally(function () {
            setSitesLoading(false);
        });
    }, [intl]);
    useEffect(function () {
        setDrives([]);
        setSelectedDriveId(null);
        setSelectedFolderId('/');
        if (!selectedSiteId)
            return;
        setDrivesLoading(true);
        api.base
            .get("".concat(config.appUrls.documents, "/api/sharepoint/sites/").concat(selectedSiteId, "/drives"))
            .then(function (x) {
            setDrives(!x.data ? [] : x.data);
        }, function (error) {
            handleHttpError(intl)(error);
        })
            .finally(function () {
            setDrivesLoading(false);
        });
    }, [selectedSiteId, intl]);
    var save = function () {
        var url = "".concat(config.appUrls.documents, "/api/documents/LinkToAdminPulse?driveId=").concat(selectedDriveId, "&folderId=").concat(selectedFolderId, "&fileId=").concat(selectedFileId, "&filename=").concat(selectedFileName);
        if (tags) {
            url = "".concat(url, "&tags=").concat(tags);
        }
        if (relationId) {
            url = "".concat(url, "&relationId=").concat(relationId);
        }
        return api.base.post(url, {}).then(function (data) {
            ToastrService.changesSaved(intl);
            return onSave(data.data);
        }, function (error) {
            handleHttpError(intl)(error);
        });
    };
    var closeModal = function () {
        onClose();
    };
    if (!show)
        return null;
    var title = function () {
        if (!sitesLoading && !drivesLoading && !foldersLoading)
            return intl.formatMessage(messages.LinkFromSharepoint);
        return (_jsxs(_Fragment, { children: [intl.formatMessage(messages.LinkFromSharepoint), _jsx("span", __assign({ className: "margin5L" }, { children: _jsx(SpinnerIcon, {}) }))] }));
    };
    return (_jsx(OkCancelModal, __assign({ title: title(), show: show, onClose: closeModal, disabled: !selectedSiteId ||
            !selectedDriveId ||
            !selectedFolderId ||
            !selectedFileId ||
            !selectedFileName, onSave: save }, { children: _jsx("div", __assign({ className: "form-horizontal" }, { children: _jsx("div", { children: _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.SharepointSite)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(AutoComplete, { mode: "edit", disabled: sitesLoading, items: sites.map(function (s) { return ({ key: s.id, label: s.name }); }), value: selectedSiteId ? { key: selectedSiteId, label: (_c = (_b = sites.find(function (s) { return s.id === selectedSiteId; })) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '' } : null, onChange: function (item) { var _a; return setSelectedSiteId((_a = item === null || item === void 0 ? void 0 : item.key) !== null && _a !== void 0 ? _a : null); } }) })), _jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.SharepointDrive)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(AutoComplete, { mode: "edit", disabled: !selectedSiteId || drivesLoading, items: drives.map(function (d) { return ({ key: d.id, label: d.name }); }), value: selectedDriveId ? { key: selectedDriveId, label: (_e = (_d = drives.find(function (d) { return d.id === selectedDriveId; })) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : '' } : null, onChange: function (item) { var _a; return setSelectedDriveId((_a = item === null || item === void 0 ? void 0 : item.key) !== null && _a !== void 0 ? _a : null); } }) })), _jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.Folder)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(SharepointFolderTree, { setLoading: setFoldersLoading, onSelectedFolderChanged: setSelectedFolderId, siteId: selectedSiteId, driveId: selectedDriveId }) })), _jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.File)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(SharepointFileSelector, { siteId: selectedSiteId, driveId: selectedDriveId, folderId: selectedFolderId, onFileSelected: function (name, fileId) {
                                    setSelectedFileName(name);
                                    setSelectedFileId(fileId);
                                }, selectedFileId: selectedFileId }) }))] })) }) })) })));
};
LinkFromSharepointModal.propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    relationId: PropTypes.string,
    tags: PropTypes.string,
};
LinkFromSharepointModal.defaultProps = {
    relationId: undefined,
    tags: undefined,
};
export default LinkFromSharepointModal;
